import { TitleCasePipe } from '@angular/common';
import { Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { StudentEligibilitiesService } from 'src/app/component/children/service/student-eligibilities.service';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { STUDENT } from 'src/app/component/common-components/multi-select-coe-student/coe-related-student';
import { Student } from 'src/app/model/student/student.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';

@Component({
    selector: 'app-counts-children-modal',
    templateUrl: './counts-children-modal.component.html',
    styleUrl: './counts-children-modal.component.scss'
})
export class CountsChildrenModalComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    settings: any = {
        '/reports/instant-eligibility-counts': {
            TITLE: 'Counts Report - Children List',
            API: undefined,
            SCHOOL_YEAR: true,
            PERFORMANCE_PERIOD: false,
            COLUMNS: ['MSD_NUMBER', 'SSID', 'NAME', 'DOB', 'SEX']
        }
    };
    currentSetting: any;

    // Component variables
    resetField: boolean = false;

    // Table display
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Tab labels
    selectedIndex: number = 0;

    // Table results
    searchResultDataSource!: MatTableDataSource<Student>;

    // Results
    results: Student[] = [];
    searchResultFilter: string = '';

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();
    titlecasePipe = new TitleCasePipe();

    constructor(
        private studentEligibilitiesService: StudentEligibilitiesService,
        router: Router,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<CountsChildrenModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.connectAPIs(studentEligibilitiesService);
        this.selectSettings(router.url);
        this.search();
    }

    connectAPIs(studentEligibilitiesService: StudentEligibilitiesService) {
        this.settings['/reports/instant-eligibility-counts'].API = function (payload: any) {
            return studentEligibilitiesService.getStudentsByEligibilityCategory(payload);
        };
    }

    selectSettings(url: string) {
        this.currentSetting = this.settings[url];
    }

    ngOnInit(): void {}

    search() {
        if (true) {
            this.isLoading = true;
            this.msg = {};
            this.searchResultFilter = '';

            this.currentSetting.API(this.generatePayload()).subscribe({
                next: (res: any) => {
                    if (res.students) {
                        this.results = JSON.parse(res.students);

                        this.results.forEach((s) => {
                            let name: string = '';
                            name += s.PERSON.LAST_NAME;
                            name += s.SECOND_LAST_NAME ? ' ' + s.SECOND_LAST_NAME : '';
                            name += ', ' + s.PERSON.FIRST_NAME;
                            name += s.PERSON.MIDDLE_INITIAL ? ' ' + s.PERSON.MIDDLE_INITIAL : '';

                            name = this.titlecasePipe.transform(name);

                            s.NAME = name;
                        });

                        this.results = this.results.sort((n1: Student, n2: Student) => (n1.NAME > n2.NAME ? 1 : -1));

                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                    }
                },
                error: (err: any) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                },
                complete: () => {
                    // Display results
                    this.isLoading = false;

                    // Set to first tab
                    this.selectedIndex = 0;
                }
            });
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.data?.chosenRegion ? [this.data?.chosenRegion.ID] : undefined;
        payload.chosenSchoolDistricts = this.data?.chosenSchoolDistrict ? [this.data?.chosenSchoolDistrict.ID] : undefined;

        payload.performancePeriod = this.data?.performancePeriod;

        payload.eligibilityCategoryType = this.data.eligibilityCategoryType;

        return payload;
    }

    updateDataSource() {
        setTimeout(() => {
            this.updateResultDataSource();
        });
    }
    updateResultDataSource() {
        // Display Columns
        this.displayedColumns = this.currentSetting.COLUMNS;

        // Data
        this.searchResultDataSource = new MatTableDataSource<Student>();
        this.searchResultDataSource.data = this.results;

        // Paginator
        this.searchResultDataSource.paginator = this.paginators.toArray()[0];

        // Sort
        this.searchResultDataSource.sort = this.sorts.toArray()[0];
        const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
        this.searchResultDataSource.sort.active = defaultSort.active;
        this.searchResultDataSource.sort.direction = defaultSort.direction;
        this.searchResultDataSource.sort.sortChange.emit(defaultSort);
        this.searchResultDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Filter
        this.searchResultDataSource.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) != -1;
        };
    }

    setFilter(searchResultDataSource: any, filter: string) {
        searchResultDataSource.filter = filter.trim().toLocaleLowerCase();
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }
}
